module.exports = __webpack_public_path__ + "media/images/video-icon-551c2290709f593a72f11f36c3c53cec.png";